document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active'); // Trigger the animation
        observer.unobserve(entry.target); // Stop observing after it's animated
      }
    });
  }, {
    threshold: 0.5 // Trigger animation when 50% of the element is visible
  });

  const dottedLines = document.querySelectorAll('.image-spotlight__item-animation');
  dottedLines.forEach(line => {
    observer.observe(line);
  });
});
